module.exports = __webpack_public_path__ + "static/img/Medal 1-4.735fb60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Medal 1-4.jpg
// module id = SbfI
// module chunks = 1